export default __webpack_public_path__ + "static/media/LP-L-EV.7d5f3181.jpg";